import * as React from 'react'

import CardContent          from '@material-ui/core/CardContent'
import ListItem             from '@material-ui/core/ListItem'
import ListItemText         from '@material-ui/core/ListItemText'
import ErrorOutline         from '@material-ui/icons/ErrorOutline'
import { FormattedMessage } from 'react-intl'

const SessionNotAvailable = () => {
  const phrasing = {
    noAppointmentAvailable:
      (
        <FormattedMessage
          id={'generic.noAppointmentAvailable'}
          defaultMessage={'No Appointment Available'}
        />
      ),
  }

  return (
    <>
      <CardContent>
        <ListItem disableGutters>
          <ErrorOutline nativeColor={'gray'}/>
          <ListItemText secondary={phrasing.noAppointmentAvailable} />
        </ListItem>
      </CardContent>
    </>
  )
}

export default SessionNotAvailable



// WEBPACK FOOTER //
// ./src/components/molecules/SessionNotAvailable.tsx